export default "__VITE_ASSET__w8XCG$BD__"